import React from 'react'
import styled, { css } from 'styled-components'
import TypographyAtom from '../../atoms/typography/typography'
import { brandOrange, brandWhite } from '../../../assets/consts/color'

const Container = styled.div`
  position: absolute;
  ${({ top }) =>
    (top || top === 0) &&
    css`
      top: ${top};
    `};
  ${({ left }) =>
    (left || left === 0) &&
    css`
      left: ${left};
    `};
  ${({ right }) =>
    (right || right === 0) &&
    css`
      right: ${right};
    `};
  ${({ bottom }) =>
    (bottom || bottom === 0) &&
    css`
      bottom: ${bottom};
    `};
  z-index: 1;
  padding: 16px;
  background-color: ${brandOrange};

  p {
    color: ${brandWhite};
  }
`

function SaleLabel({ top, left, right, bottom }) {
  return (
    <Container className="sale-label" top={top} left={left} right={right} bottom={bottom}>
      <TypographyAtom type="P" weight="Regular" copy="Sale" />
    </Container>
  )
}

export default SaleLabel
